// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_fB","advertCardList_max6":"c-a_fC"};